import { PaySftLogo } from "./logo/logo";
import { ErrorIcon } from "./icons/error";
import { TickIcon } from "./icons/tick";
import { UserTickIcon } from "./icons/user-tick";
import { DocumentIcon } from "./icons/document";
import { UploadIcon } from "./icons/upload";
import { LockIcon } from "./icons/lock";

//Sidebar Icons
import { DashboardIcon } from "./icons/sidebar/dashboard";
import { WalletIcon } from "./icons/sidebar/wallet";
import { TeamIcon } from "./icons/sidebar/team";
import { AnalyticsIcon } from "./icons/sidebar/analytics";
import { BankIcon } from "./icons/sidebar/bank";
import { LeadsIcon } from "./icons/sidebar/leads";
import { SettingIcon } from "./icons/sidebar/setting";
import { InfoIcon } from "./icons/sidebar/info";
import { InquiriesIcon } from "./icons/sidebar/inquiries";
import { GalleryIcon } from "./icons/sidebar/gallery";
import { CrownIcon } from "./icons/crown";
import { ChevronDownIcon } from "./icons/chevron-down";
import { HouseIcon } from "./icons/house";
import { EditIcon } from "./icons/edit";
import { TrashIcon } from "./icons/trash";
import { MailIcon } from "./icons/mail";
import { PhoneIcon } from "./icons/phone";
import { PlusIcon } from "./icons/plus";
import { UserEditIcon } from "./icons/user-edit";
import { UserCrossIcon } from "./icons/user-cross";
import { LogoutIcon } from "./icons/logout";
import { NotificationIcon } from "./icons/notification";
import { ChevronLeftIcon } from "./icons/chevron-left";
import { ChevronRightIcon } from "./icons/chevron-right";
import { ChevronUpIcon } from "./icons/chevron-up";
import { FilterIcon } from "./icons/filter";
import { ArrowDownLeftIcon } from "./icons/arrow-down-left";
import { ArrowUpRightIcon } from "./icons/arrow-up-right";
import { CalendarIcon } from "./icons/calendar";
import { BedIcon, BathIcon, SizeIcon } from "./icons/property-icons";
import { BuilderIcon } from "./icons/sidebar/builder";
import { ViolationIcon } from "./icons/violation";
import { ProjectComplianceIcon } from "./icons/sidebar/project-compliance";
import { DollarIcon } from "./icons/sidebar/dollar";
import { BuyerIcon } from "./icons/sidebar/buyer";
import { BrokerIcon } from "./icons/sidebar/broker";
import { LeadVisitTriageIcon } from "./icons/sidebar/leadVisitTriage";
import { CommunicationIcon } from "./icons/sidebar/communication";
import { DisputesIcon } from "./icons/sidebar/disputes";
import { AuditReportIcon } from "./icons/sidebar/auditReport";
import { SecurityIcon } from "./icons/security";
import { EyeIcon, EyeOffIcon} from "./icons/eyeIcon"

export const Logo: Record<string, any> = {
    PaySftLogo: PaySftLogo
}

export const Icons: Record<string, any> = {
    ErrorIcon: ErrorIcon,
    TickIcon: TickIcon,
    UserTickIcon: UserTickIcon,
    DocumentIcon: DocumentIcon,
    UploadIcon: UploadIcon,
    LockIcon: LockIcon,
    DashboardIcon: DashboardIcon,
    WalletIcon: WalletIcon,
    TeamIcon: TeamIcon,
    AnalyticsIcon: AnalyticsIcon,
    BankIcon: BankIcon,
    LeadsIcon: LeadsIcon,
    SettingIcon: SettingIcon,
    InfoIcon: InfoIcon,
    InquiriesIcon: InquiriesIcon,
    GalleryIcon: GalleryIcon,
    CrownIcon: CrownIcon,
    ChevronDownIcon: ChevronDownIcon,
    HouseIcon: HouseIcon,
    EditIcon: EditIcon,
    TrashIcon: TrashIcon,
    MailIcon: MailIcon,
    PhoneIcon: PhoneIcon,
    PlusIcon: PlusIcon,
    UserEditIcon: UserEditIcon,
    UserCrossIcon: UserCrossIcon,
    LogoutIcon: LogoutIcon,
    NotificationIcon: NotificationIcon,
    ChevronLeftIcon: ChevronLeftIcon,
    ChevronRightIcon: ChevronRightIcon,
    ChevronUpIcon: ChevronUpIcon,
    FilterIcon: FilterIcon,
    ArrowDownLeftIcon: ArrowDownLeftIcon,
    ArrowUpRightIcon: ArrowUpRightIcon,
    CalendarIcon: CalendarIcon,
    BedIcon: BedIcon,
    BathIcon: BathIcon,
    SizeIcon: SizeIcon,
    BuilderIcon: BuilderIcon,
    ViolationIcon: ViolationIcon,
    ProjectComplianceIcon: ProjectComplianceIcon,
    DollarIcon: DollarIcon,
    BuyerIcon: BuyerIcon,
    BrokerIcon: BrokerIcon,
    LeadVisitTriageIcon: LeadVisitTriageIcon,
    CommunicationIcon: CommunicationIcon,
    DisputesIcon: DisputesIcon,
    AuditReportIcon: AuditReportIcon,
    SecurityIcon: SecurityIcon,
    EyeIcon: EyeIcon,
    EyeOffIcon: EyeOffIcon,
}
